// extracted by mini-css-extract-plugin
export default {"flex":"uU","imgwrap":"vU","image":"wU","textinfo":"xU","producttitle":"yU","bolder":"zU","block":"AU","info":"BU","moredetails":"CU","whitebox":"EU","old_price":"FU","discount":"GU"};
    if(module.hot) {
      // 1715632478808
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  